<template>
    <div class="" :id="this.$route.name">
        <Card  back>
            <template v-slot:header>
                <h4 class="d-inline">{{title}}</h4>
                <hr>    
            </template>
            <template v-slot:content>
                <form @submit.prevent="this.$ValidForm(this)" autocomplete="off">
                    <div class="container mt-3 mb-3 text-right">
                        <div class="row">
                            <div class="col-lg-3 col-12">
                                <small id="LblSysVersion">نسخه سیستم</small>
                                <input
                                @keypress="$ValidNumber($event, 10)"
                                type="text"
                                class="form-control InputText required"
                                v-model="DataAxios.SysVersion"
                                />
                            </div>
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblDbversion">نسخه بانک اطلاعاتی</small>
                                <input
                                @keypress="$ValidNumber($event, 10)"
                                type="text"
                                class="form-control InputText required"
                                v-model="DataAxios.Dbversion"
                                />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblDataSoftWare">نام نرم افزار</small>
                                <select class="form-control " v-model="DataAxios.Selected">
                                <option value="-1">
                                    <span> نام نرم افزار را انتخاب کنید</span>
                                </option>
                                <option
                                    v-for="item in $store.state.DataSoftWare"
                                    :key="item.Id"
                                    :value="item.Id"
                                >
                                    <span>{{ item.SoftName }}</span>
                                </option>
                                </select>
                            </div>
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblDbname">نام سیستم های اطلاعاتی</small>
                                <input
                                @keypress="$Validengilsh($event, 30)"
                                type="text"
                                class="form-control InputText required"
                                v-model="DataAxios.Dbname"
                                />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblSystemName">نام بانک سیستم</small>
                                <input
                                @keypress="$Validengilsh($event, 30)"
                                type="text"
                                class="form-control InputText required"
                                v-model="DataAxios.SystemName"
                                />
                            </div>
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblImageDbname">نام بانک تصاویر</small>
                                <input
                                @keypress="$Validengilsh($event, 30)"
                                type="text"
                                class="form-control InputText required"
                                v-model="DataAxios.ImageDbname"
                                />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblLogDbname">نام بانک رویداد ها</small>
                                <input
                                @keypress="$Validengilsh($event, 30)"
                                type="text"
                                class="form-control InputText required"
                                v-model="DataAxios.LogDbname"
                                />
                            </div>
                            <div class="col-lg-6 col-12 text-right">
                                <small id="LblWebDbname">نام بانک اینترنت بانک</small>
                                <input
                                @keypress="$Validengilsh($event, 30)"
                                type="text"
                                class="form-control InputText"
                                v-model="DataAxios.WebDbname"
                                />
                            </div>
                        </div>
                    </div>
                     <btn-save-data v-if="$route.params.Status=='Add' " @Success="AddSuccess" :DataParanet="DataAxios"></btn-save-data>
                     <btn-edit-data v-if="$route.params.Status=='Edit' " :DataParanet="DataAxios"></btn-edit-data>
                </form>
            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue';
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue';

export default {
    data(){
        return{
            title:"",
            DataAxios:[]
        }
    },
    components: {
        Card,BtnSaveData,BtnEditData
    },
    created(){
         if (this.$route.params.Status) {
            if (this.$route.params.Status == "Add") {
                if (this.$session.get(this.$route.name.substring(6))[0].isMojaz == 1){
                    this.title='افـزودن سیستم اطلاعاتی'
                    this.DataAxios=JSON.parse(JSON.stringify(this.$store.state.DefineInfoSystem.Model))
                }
                else
                {
                        this.$swal({
                            title: "عدم دسترسی",
                            text: "عدم دسترسی به این صفحه",
                            icon: "error",
                            position: "center",
                            timer: false,
                            showConfirmButton: true,
                            showCancelButton: false,
                            confirmButtonColor: "#fa9500",
                            confirmButtonText: "بازگشت",
                        }).then((result) => {
                            if (result.isConfirmed) {
                            this.$router.go(-1);
                            }
                        });
                }
            }
            else{
                this.title='ویـرایـش سیستم اطلاعاتی'
            }
         }
         else
         {
            this.$router.push({ name: this.$route.name.substring(6)});
         }
     },
     mounted(){
        if(this.$route.params.Status == "Edit") {
            this.DataAxios=this.$route.params.DataRow
            this.EditObjDataAdios();
            this.$store.state.OldDataForLog=JSON.stringify(this.$route.params.DataRow)
        }
     },
      methods:{
        AddSuccess(result){
            if (result==true) {
                this.DataAxios=JSON.parse(JSON.stringify(this.$store.state.DefineInfoSystem.Model))
            }
        },
        EditObjDataAdios(){
            this.DataAxios["FromAutoNightJob"] = "";
            this.DataAxios["ToAutoNightJob"] = "";
            this.DataAxios["HarAutoNightJob"] = 24;
            this.DataAxios["FromAutoReIndex"] = "";
            this.DataAxios["ToAutoReIndex"] = "";
        }
    }
}
</script>
<style scoped>
/* hr{
    background:var(--sidebar-color-item) !important;
} */
</style>